import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Checkbox, ControlLabel } from "react-bootstrap";
import { ReactSelect } from "../../../../components";

class SelectBox extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			includeInactive: false,
		};
	}

	componentDidUpdate({ filter: prevFilter }) {
		const { filter } = this.props;
		if (prevFilter.includeInactiveDisabled !== filter.includeInactiveDisabled) {
			// This ESLint rule could possibly be disabled permanently. Further discussions will be necessary, but disabling in this file for right now
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({ includeInactive: !filter.includeInactiveDisabled });
		}
	}

	handleOnCheckboxChange = () => {
		const { filter } = this.props;
		const { includeInactive } = this.state;

		const currentValue = !includeInactive && !filter.includeInactiveDisabled;
		this.setState({ includeInactive: currentValue }, () => {
			filter.onIncludeInactiveChange(currentValue);
		});
	};

	render() {
		const { lang } = global;
		const { filter, handleOnFilter, disabled } = this.props;
		const { includeInactive } = this.state;

		return (
			<FormGroup>
				<Choose>
					<When condition={filter.inactiveOption}>
						<div className="flex">
							<ControlLabel className="flex-3">{filter.name}</ControlLabel>
							<div className="flex">
								<Checkbox
									checked={includeInactive}
									onChange={this.handleOnCheckboxChange}
									className="margin-top-0 margin-bottom-0"
									disabled={filter.includeInactiveDisabled}
								>
									{lang.t("Include Inactive")}
								</Checkbox>
							</div>
						</div>
					</When>
					<Otherwise>
						<ControlLabel>{filter.name}</ControlLabel>
					</Otherwise>
				</Choose>
				<ReactSelect
					value={filter.value}
					name={filter.name}
					onChange={e => handleOnFilter(e, filter.property)}
					options={filter.data}
					isLoading={filter.loading}
					isClearable
					isDisabled={disabled}
				/>
			</FormGroup>
		);
	}
}

SelectBox.propTypes = {
	filter: PropTypes.object,
	handleOnFilter: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};

SelectBox.defaultProps = {
	filter: {},
	disabled: false,
};

export default SelectBox;
